import { render, staticRenderFns } from "./PolicyRenew.vue?vue&type=template&id=9aafb5ec"
import script from "./PolicyRenew.vue?vue&type=script&lang=js"
export * from "./PolicyRenew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports